export default function EventDatePastBagde() {
  return (
    <div className="bg-gray-200 text-gray-500 rounded inline-flex px-4 py-2 text-sm font-semibold">
      Evento pasado
    </div>
  );
}
